import { createSlice } from '@reduxjs/toolkit';
import {fetchAllAssignHomeOwnerDataApi} from '../HomeownerApi';

const getAllAssignHomeOwnerDataSlice = createSlice({
  name: 'getAllAssignHomeOwnerData',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchAllAssignHomeOwnerDataApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAssignHomeOwnerDataApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllAssignHomeOwnerDataApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default getAllAssignHomeOwnerDataSlice.reducer;
